import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import personalizationGraphData from './assets/PersonalizationGraphData.png'
import personalizationGraphDataWebp from './assets/PersonalizationGraphData.webp'
import personalizationGraphDataWebp2x from './assets/PersonalizationGraphData@2x.webp'

const copy = {
  heading: `It's almost unanimous—89% of leaders believe personalization is crucial to their business’ success in the next three years.`,
  description: [
    `This is our fifth-annual <b>State of Personalization</b> report after all. If we didn’t believe in (or the data didn’t support) the intrinsic value of personalization to business growth, we’d have called it quits long ago.`,
    `And, yet again, our findings show that if brands want to win over hearts, minds, and wallets, they need to ditch the one-size-fits-all approach to personalization. Instead, it's all about using data and technology to deliver that perfect blend of relevancy, authenticity, and anticipation.`,
  ],
}

export const BusinessLeaders = () => {
  return (
    <Wrapper>
      <SectionComponent variant="2Col">
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            {copy.description.map((text, index) => (
              <CopyText.Description key={index} tag="p" dangerouslySetInnerHTML={{ __html: text }} />
            ))}
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <picture>
            <source
              type="image/webp"
              srcSet={`${personalizationGraphDataWebp}, ${personalizationGraphDataWebp2x} 2x`}
            />
            <Image width="512" height="593" src={personalizationGraphData} alt={`Personalization Graph Data Image`} />
          </picture>
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default BusinessLeaders
